<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>1st Installment Payment</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" >
                    <v-col cols="12" sm="3">
                        <p class="mb-1"><b>Academic Year</b><v-icon class="pb-2 pl-1" color="error">*</v-icon></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="aylist"
                            item-text="academicyear" item-value="ay_id" :loading="onload_loader"
                            @change="getApplicationForm(ay)" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="3" v-if="this.form_no_list.length >0">
                        <p class="mb-1"><b>Application Forms</b><v-icon class="pb-2 pl-1" color="error">*</v-icon></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="form_no" :items="form_no_list"
                            item-text="display_admission_form_no" item-value="id" outlined
                            persistent-hint hint="Please Select Application Form (Shown Only Selected Forms)" />
                    </v-col>
                    <v-col class="pt-10" sm="4" cols="12" v-if="ay && form_no">
                        <v-btn class=" button" @click="proceed()" :loading="fetch_loader">Proceed</v-btn>

                        <v-btn class="button" @click="proceed_online()" :loading="fetch_loader">Online Pay / Generate
                            PRN</v-btn>
                    </v-col>
                </v-row>
                <!-- {{is_rte_quota}} -->

                <!-- <v-row justify="center" dense v-if="this.stud_standard && this.stud_quota">
                 <v-col cols="12" sm="1" md="1"></v-col>
                 <v-col cols="12" sm="4" md="4"><b>Standard-</b>{{this.stud_standard}}</v-col>
                 <v-col cols="12" sm="1" md="1"></v-col>
                 <v-col cols="12" sm="4" md="4"><b>Quota-</b>{{this.stud_quota}}</v-col>
            </v-row> -->
            </v-card>

            <v-form id="payment-form-application" @submit.prevent="submit" v-model="disable_pay" ref="admissionfeeform">
                <v-card class="box" v-if="this.show_details_card">
                    <v-row dense justify="center">
                        <v-col cols="12" sm="3">
                            <v-text-field label="Name" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-text-field label="Admission Year" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.learner_addmission_year"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field label="Standard" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.standard"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1" md="1">
                            <v-text-field label="Quota" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.quota"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="2">
                            <v-text-field label="Primary Email" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.personal_email"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="2" md="1">
                            <v-text-field label="Phone No" class="padding-bot" readonly outlined dense
                                v-model="fees_student_master_details.mobile_no"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row dense justify="center" v-if="applicationstatus">
                        <p><strong>Your Application Form Status Is - {{applicationstatus}}</strong></p>
                    </v-row>
                    <br>
                    <v-row justify="center">
                        <!-- <v-col cols="12" sm="2" md="2"></v-col> -->
                        <v-col cols="12" sm="4" md="4">
                        <v-checkbox v-model="enable_pay" class="mt-0"
                            label="Do you want to generate PRN without fee payment?"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" v-if="Conditional_PRN_Generation_Mode">
                            <v-checkbox v-model="existing_prn" class="mt-0"
                            label="Do you want to use existing PRN?"></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="2" md="2" v-if="existing_prn">
                            <v-text-field outlined label="PRN" v-model="prn"
                                 placeholder="Please Enter PRN" name="prn" dense>
                                <template #label>
                                    PRN <span style="color: red">*</span>
                                </template></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>

                <v-card v-if="stud_name != null" class="box">
                    <span v-if="stud_name != null">
                        <input type="hidden" v-model="stud_id" name="stud_id" />
                        <input type="hidden" v-model="ay" name="academicyear" />
                        <input type="hidden" v-model="form_no" name="application_form_id" />

                        <!-- inputs:{{inputs}} -->
                        <v-btn class="button mt-4" @click="addRow" style="float: right;">Add Mode</v-btn>

                        <v-row v-for="(input, index) in inputs" :key="index" style="float: both;">
                            <v-col cols="12" sm="2">
                                <v-combobox dense rounded required :items="mode_list" item-text="name"
                                    v-model="input.mode" label="Payment Mode" name="mode" outlined />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field outlined rounded label="Transaction ID" v-model="input.trans_id"
                                    placeholder="123" name="trans_id" dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-combobox dense rounded required :items="bank_list" v-model="input.bank" label="Bank"
                                    name="bank" item-text="name" item-value="id" outlined />
                            </v-col>
                            <v-col cols="12" sm="2" md="2">
                                <v-text-field outlined rounded label="Branch Name" v-model="input.branch_name"
                                    placeholder="SBU Pune" name="branch_name" dense></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field v-if="enable_pay" disabled label="* Mode Amount" v-model="input.amount"
                                    placeholder="123" @change="calReceiptAmount"
                                    :rules="[v => !!v || 'Mode amount is required']" type="number" name="mode_amount"
                                    dense rounded outlined hint="Mode amount is required"></v-text-field>
                                <v-text-field v-else label="* Mode Amount" v-model="input.amount" placeholder="123"
                                    @change="calReceiptAmount" :rules="[v => !!v || 'Mode amount is required']"
                                    type="number" name="mode_amount" dense rounded outlined
                                    hint="Mode amount is required"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2">
                                <v-text-field rounded label="Amount" placeholder="20000" name="receipt_amount"
                                    v-model="receipt_amount" :rules="[v => !!v || 'Amount is required']" required
                                    readonly dense filled outlined></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="3">
                                <v-text-field rounded label="Receipt Remark" placeholder="Receipt Remark"
                                    name="receipt_remark" dense outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3" md="3">
                                <v-menu v-model="menu11" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense rounded outlined v-model="receipt_date" label="Receipt Date"
                                            name="receipt_date" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                            v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="receipt_date" name="receipt_date"
                                        @input="menu11 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col v-if="org_id == 'zeal'" cols="12" sm="3" md="3">
                                <v-menu v-model="menu12" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense outlined rounded v-model="mode_date"
                                            label="Transaction Date" name="mode_date" prepend-icon="mdi-calendar"
                                            readonly v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="mode_date" name="mode_date"
                                        @input="menu12 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col v-if="org_id != 'zeal'" cols="12" sm="1" md="1">
                                <v-btn text icon color="grey lighten-1" @click="deleteRow(index)"><v-icon>
                                        mdi-delete</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-row dense> </v-row>
                        <!-- {{this.installments_details}} -->
                        <span v-if="stud_name != null">
                            <v-toolbar flat dense class="toolbar">
                                <v-toolbar-title>Fees Component</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-simple-table dense class="elevation-1 table-container">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="toolbar">
                                                    <center><strong>Component</strong></center>
                                                </th>
                                                <th class="toolbar">
                                                    <center><strong>Actual</strong></center>
                                                </th>
                                                <th class="toolbar">
                                                    <center><strong>Pay Now</strong></center>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="comp in installments_details" :key="comp.id">
                                                <input type="hidden" name="fees_component_ay_id" :value="comp.id" />
                                                <td>{{ comp.feescomponent }}</td>
                                                <td>{{ comp.total_fees_amount }}</td>
                                                <td>
                                                    <input class="input text-center" type="number"
                                                        @change="calCompTotal" v-model="comp.current_amount"
                                                        name="amount_paid"
                                                        :rules="[v => !!v || 'Required' || v >= 0]" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>{{ comp_total.name }}</td>
                                                <td>{{ comp_total.amount }}</td>
                                                <td>{{ comp_total.current_amount }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <hr />
                            </v-col>
                        </span>
                        <v-card-actions>
                            <v-spacer> </v-spacer>
                            <span v-if="this.is_rte_quota == false && !enable_pay ">
                                <v-btn @click="handleSubmit" rounded :disabled="!disable_pay || hasZeroAmount"
                                    :loading="loader" class="button"
                                    :color="disable_pay ? '' : 'grey lighten-1'">Pay/Generate PRN</v-btn>
                            </span>
                            <span v-else>
                                <v-btn @click="handleSubmit" rounded v-if="this.is_rte_quota || enable_pay" :loading="loader"
                                    class="button">Pay/Generate PRN</v-btn>
                            </span>
                            <v-spacer> </v-spacer>
                        </v-card-actions>
                    </span>
                    <center>
                        Note: For RTE, Do Not Add Amount, Directly Click Pay/Generate PRN Button
                    </center>
                </v-card>
            </v-form>

            <v-dialog v-model="show_username" class="card-container" max-width="600px" v-if="show_username == true">
                <v-card class="box">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Credentials
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-row justify="center" dense>
                            <v-col cols="12" sm="8">
                                <p><b>Student Username - {{student_username}}</b></p>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense v-if="parent_username">
                            <v-col cols="12" sm="8">
                                <p><b>Parent Username - {{parent_username}}</b></p>
                            </v-col>
                        </v-row>
                        <v-row justify="center" dense>
                            <center>Note* - Password for both user's are <b>{{default_password}}</b> ....</center>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn class="button" @click="show_username= false">Close</v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="show_prn_dialog" max-width="600px">
            <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title><strong>PRN Student Details Confirmation</strong></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                <v-row>
                    <v-col cols="12"><b>PRN:</b> {{ prn_details.registration_number }}</v-col>
                    <v-col cols="12"><b>Full Name:</b> {{ prn_details.stud_fullname }}</v-col>
                    <v-col cols="12"><b>Standard:</b> {{ prn_details.standard }}</v-col>
                    <v-col cols="12"><b>Division:</b> {{ prn_details.division }}</v-col>
                </v-row>
                <v-divider class="my-2" />
                <p>Are you sure you want to proceed with this PRN?</p>
                <p style="color: red;">Note* - Selected form data will be copied to this PRN.</p>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="show_prn_dialog = false">Cancel</v-btn>
                <v-btn color="primary" @click="confirmSubmit">proceed</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </v-container>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            loader: false,
            is_rte_quota: false,
            fetch_loader: false,
            show_username: false,
            parent_username: "",
            student_username: "",
            snackbar_msg: "",
            color: "",
            // extraBreadcrumbItems: [
               

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            snackbar: false,
            overlay: false,
            headers: [
                { text: "Title", value: "title" },
                { text: "Description", value: "description" },
            ],
            inputs: [{ mode: "Cash", bank: "", trans_id: "", amount: 0, mode_date: [], branch_name: "" }],
            search: "",
            aylist: [],
            ay: "",
            form_no_list: [],
            form_no: "",
            show_details_card: false,
            fees_student_master_details: [],
            receipt_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            menu: false,
            modal: false,
            menu2: false,
            menu11: false,
            menu12: false,
            dialog: false,
            enable_pay: false,
            existing_prn:false,
            prn:"",
            fine_amount: "",
            excess_amount: "",
            comp_total: null,
            stud_id: null,
            payment_mode_list: [],
            inputs: [{ mode: "Cash", bank: "", trans_id: "", amount: 0, mode_date: [] }],
            stud_name: null,
            amount: "",
            org_id: null,
            installments_details: [],
            mode_list: [],
            bank_list: [],
            receipt_amount: 0,
            stud_standard: "",
            stud_quota: "",
            disable_pay: true,
            applicationstatus: "",
            generate_prn_without_receipt: false,default_password:"",
            onload_loader:false,
            Conditional_PRN_Generation_Mode: false,
            prn_details: [],
            show_prn_dialog: false
        }),
        computed: {
            hasZeroAmount() {
                return this.inputs.some((input) => input.amount <= 0);
            },
        },
        methods: {
            handleSubmit() {
                if (this.existing_prn) {
                    if (!this.prn) {
                        this.showSnackbar("error", "Please Enter Existing PRN");
                        return;
                    }
                    this.loader = true;
                    axios
                    .post("Admission/getStudDetailsByPRN", { prn: this.prn })
                    .then((res) => {
                        if (res.data.flag === "YES") {
                        this.prn_details = res.data.stud_data;
                        this.show_prn_dialog = true;
                        } else {
                        this.showSnackbar("error", res.data.snackbar || "PRN not found");
                        }
                    })
                    .catch(() => {
                        this.showSnackbar("error", "Something went wrong");
                    })
                    .finally(() => {
                        this.loader = false;
                    });
                } else {
                    this.submit();
                }
            },

            confirmSubmit() {
                this.show_prn_dialog = false;
                this.submit();
            },
            submit: function (e) {
                
                var form = document.getElementById("payment-form-application");
                let payload = {};

                    Array.from(form.elements).forEach((element) => {
                        if (!element.name || element.type === "file") return;
                        if ((element.type === "checkbox" || element.type === "radio") && !element.checked) return;

                        // Force these specific fields into arrays
                        if (element.name === "fees_component_ay_id" || element.name === "amount_paid") {
                            if (!payload[element.name]) payload[element.name] = [];
                            payload[element.name].push(element.value);
                        } else {
                            payload[element.name] = element.value;
                        }
                    });

                    if (this.org_id != "zeal") {
                        payload.mode_date = this.receipt_date;
                    }

                    payload.enable_pay = this.enable_pay;
                    payload.existing_prn = this.existing_prn;
                // if (this.org_id != "zeal") {
                //     formData.append("mode_date", this.receipt_date);
                // }
                // formData.append("enable_pay", this.enable_pay);    
                // formData.append("existing_prn", this.existing_prn);                         
                //  return
                console.log("payload========"+payload.existing_prn);
                
                this.loader = true;
                axios
                    .post("AdmissionForm/saveApplicationFormFees",payload,
                        {
                            headers: {
                                "Content-Type": "application/json"
                            },
                            transformRequest: [(data) => JSON.stringify(data)]
                        })
                    .then((res) => {
                        console.log("res "+res)
                        if (res.data.flag == "YES") {
                            //this.name=
                            this.showSnackbar("#4CAF50", "Payment Successful...");
                            this.parent_username = res.data.parent_username;
                            this.student_username = res.data.student_username;
                            this.default_password = res.data.default_password;
                            this.show_username = true;
                            this.loader = false;
                            //  alert("status::"+res.data.status.message)
                            this.clearData();

                            //  this.onload();
                            return;
                            // alert("success")
                        }else {
                             this.showSnackbar("error", res.data.snackbar);
                            // this.clearData();
                            //this.showcomponent=true;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.loader = false;
                        //alert("done")
                    });
                return;
            },
            clearData() {
                this.fees_student_master_details = [];
                this.student_receipt_details = [];
                this.show_details_card = false;
                //  this.show_receipts_btn = false;
                //this.show_installments_btn = false;
                this.installment_list = [];
                this.installments_details = [];
                this.mode_list = [];
                this.bank_list = [];
                this.installment_details_list = [];
                this.stud_name = null;
                this.comp_total = "";
                this.stud_id = "";
                (this.inputs = [{ mode: "Cash", bank: "", trans_id: "", amount: 0, mode_date: [] }]), (this.outstanding = null);
                this.receipt_amount = 0;
                (this.fine_amount = ""), (this.excess_amount = "");
                this.receipt_date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
                (this.stud_standard = ""), (this.stud_quota = "");
                this.enable_pay = false;
                this.existing_prn = false;
                this.prn="";
            },
            calCompTotal() {
                this.comp_total.current_amount = 0;
                for (var i = 0; i < this.installments_details.length; i++) {
                    this.comp_total.current_amount += parseFloat(this.installments_details[i].current_amount);
                }
                this.checkPay();
            },
            checkPay() {
                //alert("this.receipt_amount ---"+this.receipt_amount )
                //alert("this.comp_total.current_amount ---"+this.comp_total.current_amount )
                if (this.receipt_amount == this.comp_total.current_amount) {
                    this.disable_pay = true;
                } else if (this.receipt_amount > this.comp_total.current_amount) {
                    this.excess_amount = this.receipt_amount - this.comp_total.current_amount;
                    return;
                } else {
                    this.disable_pay = false;
                }
            },
            proceed_online(){
                // ay: this.ay,
                // application_form: this.form_no,
                localStorage.setItem("ay", this.ay);
                localStorage.setItem("application_form", this.form_no);
                let routeData = this.$router.resolve({ name: "inst-fees-payment" });
                window.open(routeData.href, "_blank");
            },
            proceed() {
                const data = {
                    ay: this.ay,
                    application_form: this.form_no,
                };
                this.overlay = true;
                this.fetch_loader = true;
                axios
                    .post("/AdmissionForm/getApplicationFormData", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.applicationstatus = res.data.applicationstatus;
                            this.stud_standard = res.data.stud_standard;
                            this.stud_quota = res.data.stud_quota;
                            (this.show_details_card = true), (this.fees_student_master_details = res.data.fees_student_master_details);
                            this.stud_name = res.data.fees_student_master_details.name;
                            this.installments_details = res.data.installments;
                            this.mode_list = res.data.mode_list;
                            this.bank_list = res.data.bank_list;
                            this.comp_total = res.data.comp_total[0];
                            this.is_rte_quota = res.data.is_rte_quota;
                            this.Conditional_PRN_Generation_Mode = res.data.Conditional_PRN_Generation_Mode;
                            // this.generate_prn_without_receipt=res.data.generate_prn_without_receipt
                            if (this.is_rte_quota == true)
                                [
                                    //this.calReceiptAmount(),
                                    (this.disable_pay = false),
                                ];
                        } else {
                            this.stud_standard = "";
                            this.stud_quota = "";
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                        this.overlay = false;
                        this.fetch_loader = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.fetch_loader = false;
                        // this.selected_date=""
                    });
            },
            getApplicationForm(ay) {
                const data = {
                    ay: ay,
                };
                this.overlay = true;
                this.fetch_loader = true;
                (this.form_no_list = []), (this.form_no = "");
                axios
                    .post("/AdmissionForm/getApplicationFormsByAy", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.form_no_list = res.data.application_forms_details;
                        } else {
                            this.form_no_list = [];
                            this.showSnackbar("red", res.data.snackbar);
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.stud_standard = "";
                            (this.stud_quota = ""), (this.form_no = "");
                        }
                        this.overlay = false;
                        this.fetch_loader = false;
                    })
                    .catch((error) => {
                        this.onerror(error);
                        this.overlay = false;
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.fetch_loader = false;
                        // this.selected_date=""
                    });
            },
            calReceiptAmount() {
                this.receipt_amount = 0;
                for (var i = 0; i < this.inputs.length; i++) {
                    this.receipt_amount += parseFloat(this.inputs[i].amount);
                }
                var pay_comp_now = this.receipt_amount;
                // for (var i = 0; i < this.installments_details.length; i++) {
                //    this.installments_details[i].current_amount = pay_comp_now;
                //     pay_comp_now = 0;
                //  }

                for (var i = 0; i < this.installments_details.length; i++) {
                    this.installments_details[i].current_amount = 0;
                    if (pay_comp_now >= this.installments_details[i].total_fees_amount) {
                        this.installments_details[i].current_amount = this.installments_details[i].total_fees_amount;
                        pay_comp_now = pay_comp_now - this.installments_details[i].total_fees_amount;
                    } else {
                        this.installments_details[i].current_amount = pay_comp_now;
                        pay_comp_now = 0;
                        //break
                    }
                    this.comp_total.current_amount += this.installments_details[i].current_amount;
                }
                this.calCompTotal();
            },
            onLoad() {
                this.onload_loader = true;
                axios
                    .post("FeesStructureInstallment/getdata")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            (this.aylist = res.data.aylist), (this.ay = res.data.curreny_ay);
                            //  this.form_no_list=res.data.application_forms_details
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.onload_loader = false;
                    });
            },
            addRow() {
                this.inputs.push({
                    mode: "Cash",
                    bank: "",
                    trans_id: "",
                    amount: 0,
                    mode_date: { value: "" },
                });
            },
            deleteRow(index) {
                this.inputs.splice(index, 1);
                this.calReceiptAmount();
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    .card-container {
        overflow-x: hidden;
        overflow: hidden;
    }
    input1 {
        width: 50%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    input[type="number"] {
        width: 50%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    .link {
        text-decoration: none !important;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }
    .datepicker-div {
        margin-top: -20px;
    }
    .datepicker-div label {
        color: #00000099;
        font-size: 12px;
        position: relative;
        top: 4px;
    }
    .datepicker {
        border: 1px solid #dddddd;
        padding: 7px 0 7px;
        border-radius: 4px;
        width: 100%;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }

    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
    }
</style>